<template>
  <div style="position: relative; width: 100%;">
    <h1
      style="
        position: absolute;
        margin: 20px 0 0 20px;
        font-size: 3rem;
        font-weight: 500;
      "
    >
      {{ header }}
    </h1>
    <img style="width: 100%; border-radius: 28px" :src="srcimg" />
  </div>
</template>

<script>
export default {
  props: ["srcimg", "header"],
};
</script>

<style>
</style>